import uuid from 'uuid/v4';

/**
 * Generates a unique action id
 * keywords: generate id, actionId
 */
const generateActionId = (): string => 'fbpa' + uuid();

export default generateActionId;
